module.exports = __webpack_public_path__ + "img/5.f29b7be7.png";